export default "__VITE_ASSET__BC7t1I36__"